import React from 'react';
export default {
  unstyled: React.createElement("p", null),
  paragraph: React.createElement("p", null),
  'header-one': React.createElement("h1", null),
  'header-two': React.createElement("h2", null),
  'header-three': React.createElement("h3", null),
  'header-four': React.createElement("h4", null),
  'header-five': React.createElement("h5", null),
  'header-six': React.createElement("h6", null),
  blockquote: React.createElement("blockquote", null),
  'unordered-list-item': {
    element: React.createElement("li", null),
    nest: React.createElement("ul", null)
  },
  'ordered-list-item': {
    element: React.createElement("li", null),
    nest: React.createElement("ol", null)
  },
  media: React.createElement("figure", null),
  atomic: React.createElement("figure", null)
};